app.service('productTabMatches',function(console, productCardConfig, cartManager) {
	var $self, $accessoriesGroupsBox, $accessoriesList, $addToCart;
	var currentGroup;

	function scrollActiveGroupTabIntoView() {
		const ELEMENT_PADDING_LEFT = 15;
		if($self.find('.js-category-tab.is-active').length){
			const scrollLeft = $self.find('.js-category-tab.is-active').offset().left - ELEMENT_PADDING_LEFT;
			$accessoriesGroupsBox.scrollLeft(scrollLeft);
		}
	}

	function loadSuccess(html){
		console.log('ZAŁADOWANIE ZAKŁADKI: PASUJE DO');
		$self.html(html);
		setElements();
		setEvents();
		scrollActiveGroupTabIntoView();
		$accessoriesList.removeClass('loading');

		if(currentGroup!==0){
			$.scrollTo($accessoriesList ,100);
		}
		checkCart();
	}
	function loadError(){
		console.log('BŁĄD ŁADOWANIA ZAKŁADKI');
		$self.html('<div class="tab-error">Wystąpił błąd ładowania zakładki. Prosimy spróbować później</div>');
		$accessoriesList.removeClass('loading');
	}
	function checkCart() {
		cartManager.checkRelatedProducts();
	}
	function load(groupName){
		if($self.length && groupName!=currentGroup){
			if(groupName !== 0){
				$accessoriesList.addClass('loading');
			}
			currentGroup = groupName;
			var config=productCardConfig.getData();
			var data={
				nodeid:config.nodeId,
				preview:config.preview,
				showAll:true,
				'group-id':groupName,
				'product-link-name':config.linkName
			};
			$.ajax({
				url:'/product-card-matches.ltr',
				data:data,
				success:function(html){
					loadSuccess(html);
				},
				error:function(){
					loadError();
				}
			});
		}
	}
	function setEvents(){
		$accessoriesGroupsBox.on('click', '.js-category-tab', function() {
			load($(this).data('group'));
			UA.pageInteraction('Pasuje Do', 'Kategoria - ' + $(this).text().trim());
		});
		$addToCart.on('click',function(){
			if($(this).is(':checked')) {
				addAccessoryToCart($(this).val());
				UA.pageInteraction('Pasuje Do', 'Dodaj do koszyka');
			} else {
				removeAccessoryFromCart($(this).val());
			}
		});
		$(document).on('cartReady', function(){
			checkCart();
		});
	}
	function addAccessoryToCart(value) {
		cartManager.simpleAddProduct({
			addedFrom:'ACCESS_CARD',
			productId:value
		});
	}
	function removeAccessoryFromCart(value) {
		cartManager.removeProduct({
			productId:value
		});
	}
	function setElements(){
		$self=$('#matches');
		$accessoriesGroupsBox = $('.js-accessories-groups', $self);
		$accessoriesList = $('.js-accessories-list', $self);
		$addToCart = $('.js-add-accessory-to-cart-checkbox', $self);
	}
	function init(){
		setElements();
		setEvents();
		load(0);
	}
	return {
		init:init
	};
});
